module.exports = __webpack_public_path__ + "static/dumpster-single-401ce5e74be9594cc238223cad2239b6.jpg";